import React from 'react';
import styled from '@emotion/styled';

import { IMAGE_URL } from '@ordermentum/ui-constants';

type SizeT = 'sm' | 'md' | 'lg';
type AnimationType = 'success-confetti';

type AnimationProps = {
  type: AnimationType;
  size?: SizeT;
  loop?: boolean;
};

const SIZE_MAP = {
  sm: '64px',
  md: '96px',
  lg: '128px',
};

const ANIMATION_MAP = {
  'success-confetti': 'success-confetti.mp4',
};

export const AnimationContainer = styled('div')`
  margin: 0.5rem 0;
`;

export const Animation = ({
  type,
  size = 'md',
  loop = false,
}: AnimationProps) => {
  const video = ANIMATION_MAP[type];
  const src = `${IMAGE_URL}/${video}`;
  return (
    <AnimationContainer>
      <video
        src={src}
        width={SIZE_MAP[size]}
        height={SIZE_MAP[size]}
        autoPlay
        loop={loop}
        muted
        playsInline
      />
    </AnimationContainer>
  );
};
